import cn from 'classnames';
import React from 'react';
import type {ClassValue} from '../helpers/react-helpers'

interface IconProps {
    name: string
    color?: React.CSSProperties['color']
    title?: string|nil
    className?: ClassValue // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/classnames/types.d.ts
}

type ElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;

export default function Icon({name, color, className, title}: IconProps) {
    const attrs: ElementProps = {
        className: cn([name, className]),
        title: title || undefined,
    };
    if (color) {
        attrs.style = {color};
    }
    return <i {...attrs}/>
}

interface SpinnerProps {
    size?: number
    strokeWidth?: number
    color?: React.CSSProperties['color']
}

export const SpinnerSvg: React.FC<SpinnerProps> = ({size=13*1.2*1.2,strokeWidth=2.5,color}) => {
    return (
        <svg className="spinner" style={{'--spinner-size':size,'--spinner-stroke-width':strokeWidth,'--spinner-color':color}}>
            <circle cx={size/2} cy={size/2} r={(size-strokeWidth)/2}/>
        </svg>
    )
}

export const Spinner: React.FC = () => {
    return (
        <div className="mrkn-spin-wrap"><SpinnerSvg/></div>
    )
}



